import React, { Fragment } from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import BookmarkAddedOutlinedIcon from '@mui/icons-material/BookmarkAddedOutlined';
import { deleteWithIcon } from '../../lib/actions';
import {
    DeleteIcon,
    DownloadReprtIcon,
    DuplicateIcon,
    VerticalDividerIcon,
} from '../../svg/UtilsIcons';

const TemplateDetailsHeaderActions = ({
    t,
    details,
    edit,
    loading,
    alert,
    navigate,
    canOpenReportDialog,
    canAddTemplate,
    canAddTemplateExamples,
    isCompactHeaderActions,
    isHeaderActionsMenuOpen,
    setIsHeaderActionsMenuOpen,
    headerActionsMenuRef,
    downloadReportActionLabel,
    setDownloadReportState,
    duplicateTemplate,
    openMarkAsExampleDialog,
    handleCancelEdit,
    isApplyDisabled,
    updateTemplate,
    setEdit,
}) => (
    <>
        {!isCompactHeaderActions && (
            <div className="details-inline-actions">
                {canOpenReportDialog && (
                    <button
                        type="button"
                        className="details-inline-action-btn"
                        onClick={() =>
                            setDownloadReportState({
                                open: true,
                                template: details,
                            })
                        }
                    >
                        <DownloadReprtIcon />
                    </button>
                )}

                {canAddTemplate && (
                    <button
                        type="button"
                        className="details-inline-action-btn"
                        onClick={duplicateTemplate}
                    >
                        <DuplicateIcon />
                    </button>
                )}

                {canAddTemplateExamples && edit.mode !== 'edit' && (
                    <button
                        type="button"
                        className="details-inline-action-btn"
                        onClick={openMarkAsExampleDialog}
                        title={t.markAsExample || 'Mark as Example'}
                        aria-label={t.markAsExample || 'Mark as Example'}
                    >
                        <BookmarkAddedOutlinedIcon fontSize="small" style={{ color: "var(--details-icons-color, var(--sidenav-icons, #FFFFFF))" }} />
                    </button>
                )}

                <span className="details-inline-divider">
                    <VerticalDividerIcon />
                </span>

                <button
                    type="button"
                    className="details-inline-action-btn details-inline-delete-btn"
                    onClick={() =>
                        deleteWithIcon(
                            details.id,
                            details.icon,
                            'template',
                            () => navigate('/configuration/templates'),
                            alert,
                        )
                    }
                >
                    <DeleteIcon />
                </button>
            </div>
        )}

        <div className="details-head-right">
            {isCompactHeaderActions ? (
                <div className="details-head-action-group" ref={headerActionsMenuRef}>
                    <button
                        type="button"
                        className="details-inline-action-btn details-head-more-btn"
                        onClick={() => setIsHeaderActionsMenuOpen((prev) => !prev)}
                        aria-label={t.moreActions || 'More actions'}
                        aria-expanded={isHeaderActionsMenuOpen}
                    >
                        <MoreHorizIcon />
                    </button>

                    {isHeaderActionsMenuOpen ? (
                        <div className="details-actions-menu details-head-actions-menu open">
                            {canOpenReportDialog && (
                                <button
                                    type="button"
                                    className="details-actions-menu-item"
                                    onClick={() => {
                                        setIsHeaderActionsMenuOpen(false);
                                        setDownloadReportState({
                                            open: true,
                                            template: details,
                                        });
                                    }}
                                >
                                    <DownloadReprtIcon />
                                    <span>{downloadReportActionLabel}</span>
                                </button>
                            )}

                            {canAddTemplate && (
                                <button
                                    type="button"
                                    className="details-actions-menu-item"
                                    onClick={() => {
                                        setIsHeaderActionsMenuOpen(false);
                                        duplicateTemplate();
                                    }}
                                >
                                    <DuplicateIcon />
                                    <span>{t.duplicate || 'Duplicate'}</span>
                                </button>
                            )}

                            {canAddTemplateExamples && edit.mode !== 'edit' && (
                                <button
                                    type="button"
                                    className="details-actions-menu-item"
                                    onClick={() => {
                                        setIsHeaderActionsMenuOpen(false);
                                        openMarkAsExampleDialog();
                                    }}
                                >
                                    <BookmarkAddedOutlinedIcon fontSize="small" />
                                    <span>{t.markAsExample || 'Mark as Example'}</span>
                                </button>
                            )}

                            <button
                                type="button"
                                className="details-actions-menu-item danger"
                                onClick={() => {
                                    setIsHeaderActionsMenuOpen(false);
                                    deleteWithIcon(
                                        details.id,
                                        details.icon,
                                        'template',
                                        () => navigate('/configuration/templates'),
                                        alert,
                                    );
                                }}
                            >
                                <DeleteIcon />
                                <span>{t.delete || 'Delete'}</span>
                            </button>

                            <div className="details-actions-menu-sep" />

                            {edit.mode === 'edit' ? (
                                <Fragment>
                                    <button
                                        type="button"
                                        className="details-actions-menu-item"
                                        onClick={() => {
                                            setIsHeaderActionsMenuOpen(false);
                                            handleCancelEdit();
                                        }}
                                    >
                                        <span />
                                        <span>{t.cancel || 'Cancel'}</span>
                                    </button>

                                    <button
                                        type="button"
                                        className="details-actions-menu-item"
                                        disabled={isApplyDisabled}
                                        onClick={() => {
                                            if (isApplyDisabled) return;
                                            setIsHeaderActionsMenuOpen(false);
                                            updateTemplate();
                                        }}
                                    >
                                        <span />
                                        <span>{t.apply || 'Apply'}</span>
                                    </button>
                                </Fragment>
                            ) : (
                                <button
                                    type="button"
                                    className="details-actions-menu-item"
                                    onClick={() => {
                                        setIsHeaderActionsMenuOpen(false);
                                        setEdit((prev) => ({ ...prev, mode: 'edit' }));
                                    }}
                                >
                                    <span />
                                    <span>{t.edit || 'Edit'}</span>
                                </button>
                            )}
                        </div>
                    ) : null}
                </div>
            ) : edit.mode === 'edit' ? (
                <div className="details-head-action-group edit-mode-action-bar">
                    <button
                        type="button"
                        className="btn btn-cancel-details edit-mode-action-btn edit-mode-action-btn--cancel"
                        onClick={handleCancelEdit}
                    >
                        {t.cancel}
                    </button>

                    <button
                        type="button"
                        className={`btn asset-edit-main-btn edit-btn-save edit-mode-action-btn edit-mode-action-btn--apply ${
                            isApplyDisabled
                                ? 'disabled'
                                : ''
                        }`}
                        disabled={isApplyDisabled || loading}
                        onClick={updateTemplate}
                    >
                        {t.apply}
                    </button>
                </div>
            ) : (
                <button
                    className="btn edit-btn devices-primary-btn"
                    style={{
                        cursor: 'pointer',
                    }}
                    onClick={() =>
                        setEdit((prev) => ({ ...prev, mode: 'edit' }))
                    }
                >
                    {t.edit}
                </button>
            )}
        </div>
    </>
);

export default TemplateDetailsHeaderActions;
